import ClientForm from "../Client/ClientForm";
import CollaboratorForm from "../Collaborator/CollaboratorForm";
import Queries from "../../queries/queries2";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import SupplierForm from "../Supplier/SupplierForm";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

const TierCreateSideModal = ({
  title,
  createSideModalVisible,
  setCreateSideModalVisible,
  sendNotification,
  companyDefaultInfos,
  onSubmit,
  showSuppliers,
  showCollaborators,
  showClients,
  inputName,
  intl,
  getDefaultCountry
}) => {
  const tiersType = showClients
    ? "client"
    : !showSuppliers && showCollaborators
      ? "collaborator"
      : "supplier";
  const Component = showClients
    ? ClientForm
    : !showSuppliers && showCollaborators
      ? CollaboratorForm
      : SupplierForm;
  return (
    <SideModal
      title={
        title +
        " " +
        intl.formatMessage({ id: `ids_${tiersType}` }).toLowerCase()
      }
      width="medium-wide"
      visible={createSideModalVisible}
      handleClose={() => setCreateSideModalVisible(false)}>
      <Component
        inSideModal
        inputName={inputName}
        currency={companyDefaultInfos.company.currency}
        onSubmit={values => onSubmit(tiersType, values)}
        companyDefaultInfos={companyDefaultInfos}
        sendNotification={sendNotification}
        companyId={companyDefaultInfos.company.id}
        cancel={() => setCreateSideModalVisible(false)}
        getDefaultCountry={getDefaultCountry}
      />
    </SideModal>
  );
};

export default compose(
  graphql(Queries.GetCountryByLabel, {
    options: ({ countryCode }) => ({
      variables: { label: (countryCode && { countryCode }.countryCode) || "FR" }
    }),
    name: "getDefaultCountry"
  })
)(injectIntl(TierCreateSideModal));
